import { Row, Col, Container, Card, Button, Table, Badge, Dropdown, Form, Spinner, Modal, InputGroup } from "react-bootstrap";
import Layout from "../../components/Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Paginator from "../../components/table/Paginator";
import { useEffect, useRef, useState } from "react";
import ngn from '../../assets/images/NGN.svg';
import usd from '../../assets/images/USA.svg';
import cad from '../../assets/images/CAD.svg';
import gbp from '../../assets/images/gbp.svg';
import ghs from '../../assets/images/ghs.svg';
import rsa from '../../assets/images/rsa.svg';
import kes from '../../assets/images/kes.svg';
import rwf from '../../assets/images/rwf.svg';
import rotateKnob from '../../assets/images/rotate.svg';
import DrewsModal from "../../components/modal/DrewsModal";
import { useDispatch, useSelector } from "react-redux";
import { checkBalance, createBulkPaycode, fxExchange, getBanks, getFaasPaycodeDetails, getFasepayTransactionHistory, getRates, getTransactionHistory, getTransferCharges, payWithFase, sendPaymentRequest } from "../../redux/slices/account.service";
import Swal from "sweetalert2";
import formatCurrency from "../../utils/currencyFormmter";
import { getWallets, withdrawalRequest } from "../../redux/slices/users";
import dateFormatter from "../../utils/dateFormatter";
import fase from "../../assets/images/fasewallet.svg"
import { completeFasePayWidgetTour } from "../../redux/slices/auth";
import CurrencyDropdown from "../../components/CurrencyDropdown";
import RecordFilter from "../../components/RecordFilter";
import AmountInput from "../../components/AmountInput";
import { managerGetTransactionHistory, managerGetWallets, managerPayWithFase } from "../../redux/slices/managers.slice";
import Select from 'react-select'

const FasePay = () => {

    const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
    const isLoaded = useRef(false)
    const { user = {} } = useSelector((state) => state.auth)

    const dispatch = useDispatch();
    const { fasepay_widget } = useSelector((state) => state.auth)

    const initialState = {
        transferForm: false,
        modalShow: false,
        showForm: false,
        show: false,
        showBalance: false,
        transaction: {},
        loading: false,
        errorMessage: null,
        genVoucher: false,
        paycodes: [],
        errors: {},
        paginationData: {next: '', prev: ''},
        payload: {
            to_currency: 'NGN', 
            currency: 'USD', 
            amount: 1,
            page: 1,
            from_date: '',
            to_date: '',
            status: '',
            download: '',
            filter_by: '',
            sort_by: '',
            filter: '',
            gateway: 'FasePay',
            paycode: '',
            account_number: '',
            narration: '',
        },
        page: 1,
        fxForm: false,
        show_widget: true,
        widget_state: 'first',
        wallet: {},
        transactions: [],
        rates: [],
        conversion: {},
        withdrawal: false,
        pinValue: ['', '', '', ''],
        fee: 0.00,
        charges: 0,
        loadingRequest: false,
        banks: [],
        sendingRequest: false,
        bankList: [],
        converted: {
            amount: 0,
            currency: 'GHS',
            from_currency: 'NGN',
        },
    }

    const [state, setState] = useState(initialState)
    const usd_to_nara = state.rates?.find((r) => r.currency === 'USD')
    const cad_to_nara = state.rates?.find((r) => r.currency === 'CAD')
    const [faasPaycode, setFaasPayCode] = useState({})
    const [proceedToPayment, setProceed] = useState(false)

    const wallets  = [
        {
            name: 'Naira Wallet',
            currency: 'NGN',
            logo: ngn,
            api_label: 'ngn_amount',
        },
        {
            name: 'USD Wallet',
            currency: 'USD',
            logo: usd,
            api_label: 'usd_amount',
        },
        {
            name: 'GBP Wallet',
            currency: 'GBP',
            logo: gbp,
            api_label: 'gbp_amount',
        },
        {
            name: 'CAD Wallet',
            currency: 'CAD',
            logo: cad,
            api_label: 'cad_amount',
        },
        {
            name: 'GHS Wallet',
            currency: 'GHS',
            logo: ghs,
            api_label: 'ghs_amount',
        },
        {
            name: 'RSA Wallet',
            currency: 'RSA',
            logo: rsa,
            api_label: 'rsa_amount',
        },
        {
            name: 'KES Wallet',
            currency: 'KES',
            logo: kes,
            api_label: 'kes_amount',
        },
        {
            name: 'RWF Wallet',
            currency: 'RWF',
            logo: rwf,
            api_label: 'rwf_amount',
        },
    ];


    useEffect(() => {
        if(!isLoaded.current) {
            loadWallets()
            loadRates()
            getSystemCharges()
            if(fasepay_widget) {
                setState((prevState) => ({...prevState, show_widget: false}))
            }
            loadTransactions()
            isLoaded.current = true
        }
    }, [])

    useEffect(() => {
        convertCurrency()
    }, [state.payload])

    useEffect(() => {
        if(state.payload.page > 1) {
            loadTransactions()
        }
    }, [state.payload?.page])

    useEffect(() => {
        if((state.payload.currency === 'GHS' || state.payload.currency === 'KES') && state.transferForm) {
            loadBanks()
            convertTransferCurrency()
        }
    }, [state.payload?.currency])

    useEffect(() => {
        if((state.payload.currency === 'GHS' || state.payload.currency === 'KES') && state.transferForm) {
            convertTransferCurrency()
        }
    }, [state.payload?.amount])

    const selectTransaction = (item) => {
        setState((prevState) => ({...prevState, show: true, paycode: item}))
    }

    const handleInput = (event) => {
        const { name, value } = event.target
        setState((prevState)=> ({...prevState, payload:{...prevState.payload, [name]: value}}))
    }

    const handleValidation = (event) => {

        const regex = /^\d*\.?\d*$/;
        const pattern = /[a-zA-Z0-9]+[\.]?([a-zA-Z0-9]+)?[\@][a-z]{3,9}[\.][a-z]{2,5}/g;
    
        const {name, value} = event.target
        if(value === '' && event.target.attributes.required) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }

        else if (name ==='amount' && !regex.test(parseFloat(value.replace(/[^\d.]/g, '')))) {
            event.target.style = "border: 1px solid red"
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors, [name]: `${name[0].toUpperCase() + name.split('_').join(' ').slice(1)} is required`}}))
        }
        else {
            event.target.style = "border-style: transparent"
            delete state.errors[name]
            setState((prevState) => ({ ...prevState, errors: {...prevState.errors}}))
        }
    }

    const createPayCode = () => {
        setState((prevState) => ({...prevState, loading: true}))
        dispatch(createBulkPaycode(state.payload))
        .then((response) => {
            if(response?.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: response?.payload?.message || 'Paycode created successfully'
                })
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response?.payload?.message || 'Unable to create paycode'
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const applyPaycode = () => {
        if(!state.payload.amount && !state.payload.paycode && !state.payload.secret_word && !state.payload.currency)  { return }
        setState((prevState) => ({...prevState, loading: true}))
        const action = user?.user_type === 'owner' ? payWithFase(state.payload) : managerPayWithFase(state.payload)
        dispatch(action)
        .then((response) => {
            if(response.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message
                })
                .then(() => setState((prevState) => ({...prevState, showForm: false})))
            }
            else {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const paycodeBalance = () => {
        if(!state.payload.paycode && !state.payload.secret_word)  {  return }

        setState((prevState) => ({...prevState, loading: true}))
        dispatch(checkBalance(state.payload))
        .then((response) => {
            if(response.payload?.success === true) {
                Swal.fire({
                    icon: 'info',
                    text: response.payload?.message
                })
                .then(() => setState((prevState) => ({...prevState, showBalance: false})))
            }
            else {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: response?.payload?.message || 'Unable to check balance, try again'
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }
    
    const handlePagination = (data) => {
        setState((prevState) => ({...prevState, payload: {...prevState.payload, page: data}}))
    }

    const loadWallets = () => {
        const action = user?.user_type === 'owner' ? getWallets() : managerGetWallets()
        dispatch(action)
        .then((response) => { 
            if(response.payload?.success === true) {
                setState((prevState) => ({...prevState, wallet: response?.payload?.data[0]}))
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response?.payload?.message || 'Unable to fetch wallet'
                })
            }
        })
    }

    const sellFx = () => {
        Swal.fire({
            icon: 'warning',
            text: 'Do you wish to proceed?',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'No, Cance',
            confirmButtonText: 'Yes, Proceed'
        })
        .then((result) => {
            if(result.isConfirmed) {
                setState((prevState) => ({...prevState, loading: true}))
                dispatch(fxExchange(state.payload))
                .then((response) => {
                    if(response.payload?.success === true) {
                        setState((prevState) => ({...prevState, fxForm: false}))
                        Swal.fire({
                            icon: 'success',
                            text: response?.payload?.message
                            // text: `An equivalent of ${formatCurrency(payload.amount, payload.currency).with_currency} (${formatCurrency(conversion.amount, payload.to_currency).with_currency}) has been credited to you`, //response?.payload?.message
                        })
                        .then(() => {
                            loadWallets()
                        })
                    }
                    else {
                        Swal.fire({
                            icon: 'error',
                            text: response?.payload?.message
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, loading: false})))
            }
        })
    }

    const loadTransactions = () =>  {
        setState((prevState) => ({...prevState, loading: true}))
        const action = user?.user_type === 'owner' ? getTransactionHistory(state.payload) : managerGetTransactionHistory(state.payload)
        dispatch(action)
        .then((response) => {
            let result = []
            let pagination = {}
            if(response.payload.results) {
                result = response?.payload?.results
            }

            if(response.payload?.next || response.payload?.previous) {
                pagination = {
                    next: response.payload?.next,
                    prev: response.payload?.previous,
                }
            }
            setState((prevState) => ({...prevState, transactions: result, paginationData: pagination}))
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const fetchPaycodeDetails = () =>  {
        setState((prevState) => ({...prevState, loadingRequest: true}))
        const action = user?.user_type === 'owner' ? getFaasPaycodeDetails(state.payload.paycode) : getFaasPaycodeDetails(state.payload.paycode)
        dispatch(action)
        .then((response) => {
            if(response.payload?.data) {
                setFaasPayCode(response?.payload?.data)
            } else {
                Swal.fire({
                    icon: "error",
                    text: response?.payload?.message || "Paycode not found"
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loadingRequest: false})))
    }

    const manageWidget = () => {
        setState((prevState) => ({...prevState, show_widget: false}))
        dispatch(completeFasePayWidgetTour())
    }

    const loadRates = () => {
        dispatch(getRates())
        .then((response) => {
            if(response.payload?.data) {
                setState((prevState) => ({...prevState, rates: response?.payload?.data}))
            }
        })
    }

    const convertCurrency = () => {
        let converted = {}
        let from_currency = state.payload.currency
        let to_currency = state.payload.to_currency
        let amount = state.payload.amount
        let rate = state.rates.find((rate) => rate.currency === from_currency)
        let to_rate = state.rates.find((rt) => rt.currency === to_currency)
        if(rate) {
            converted = {
                amount: amount * rate.rate,
                currency: to_currency
            }
        }
        else if(from_currency === 'NGN') {
            converted = {
                amount: to_rate ? amount / to_rate.rate : amount * 1,
                currency: to_currency
            }
        }
        setState((prevState) => ({...prevState, conversion: converted}))
    }

    const handleCurrencySelect = (event, name) => {
        setState((prevState) => ({...prevState, payload: {...prevState.payload, [name]: event.value}}))
    }

    const handleOtpInputs = (index, event) => {
        
        const value = event.target.value

        if(isNaN(value)) return;

        const pinValues = [...state.pinValue]
        pinValues[index] = value
        setState((prevState) => ({...prevState, pinValue: pinValues}))

        if (value !== '' && index < 3) {
            inputRefs[index + 1].current.focus()
        }        
    }

    const sendWithrawalRequest = () => {
        if (!state.payload.amount) {return}
        if(!state.pinValue.length || state.pinValue.join("") === '' || state.pinValue.join("").length < 4) {
            setState((prevState) => ({...prevState, loading: false}))
            return;
        }

        setState((prevState) => ({...prevState, loading: true}))
        dispatch(withdrawalRequest({amount: state.payload.amount, pin: state.pinValue.join("")}))
        .then((response) => {
            if(response.payload?.success === true) {
                Swal.fire({
                    icon: 'success',
                    text: response.payload?.message
                })
                .then(() => {
                    setState((prevState) => ({...prevState, withdrawal: false}))
                    loadWallets()
                })
            }
            else if(response.payload?.success === false) {
                Swal.fire({
                    icon: 'error',
                    text: response.payload?.message
                })
            }
        })
        .finally(() => setState((prevState) => ({...prevState, loading: false})))
    }

    const calculateFees = ()  => {
        let amount = parseFloat(state.payload.amount);
        const percentage = (amount / 100) * state.charges
        const fee = percentage < 2500 ? percentage : 2500 
        setState((prevState) => ({...prevState, fee: fee}))
        return fee
    }

    const getSystemCharges = () => {
        dispatch(getTransferCharges())
        .then(response => {
            if(response.payload !== 'undefined') {
                const data = response.payload
                if(data.length) {
                    const charge = data.find(item => item.name === 'withdrawal')
                    if(charge.value) {
                        setState((prevState) => ({...prevState, charge: charge.value}))
                    }
                }
            }
        })
    }

    const handleSearch = () => {
        loadTransactions()
    }

    const handleAmountUpdate = (data) => {
        const cleanAmount = data.split(',').join('')
        setState((prevState) => ({...prevState, payload: {...prevState.payload, amount: cleanAmount}}))

        // if(state.payload.currency === 'KES' || state.payload.currency === 'GHS') {
        //     console.log("currency hereh ", state.payload.currency)
        //     convertTransferCurrency()
        // }
    }

    const initiateTransfer = () => {
        if(state.payload.narration === '' || state.payload.account_number === '') {
            Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Please fill all required fields to proceed'
            })
            return;
        }
        Swal.fire({
            icon: 'warning',
            text: 'Do you wish to proceed?',
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: 'No, Cancel',
            confirmButtonText: 'Yes, Proceed'
        })
        .then((result) => {
            if(result.isConfirmed) {
                setState((prevState) => ({...prevState, sendingRequest: true}))
                dispatch(sendPaymentRequest({
                    "currency": state.payload?.currency,
                    "amount": state.payload.amount.toFixed(2),
                    "bank_code": state.payload.bank_code,
                    "bank_name": state.payload.bank_name,
                    "account_number": state.payload.account_number,
                    "narration": state.payload.narration,
                    "pin": state.pinValue.join(""),
                }))
                .then((response) => {
                    if(response.payload?.success === true || response.payload?.success === 'True') {
                        Swal.fire({
                            icon: 'success',
                            text: response.payload?.message
                        })
                        .then(() => {
                            setState((prevState) => ({
                                ...prevState, 
                                transferForm: false, 
                                payload: {...prevState.payload, amount: 1},
                                converted: {...prevState.converted, amount: 0},
                            }))
                            loadWallets()
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'Error',
                            icon: 'error',
                            text: response.payload?.message || 'Unable to process transfer request, try again'
                        })
                    }
                })
                .finally(() => setState((prevState) => ({...prevState, sendingRequest: false})))
            }
        })
    }   

    const loadBanks = () => {
        dispatch(getBanks(state.payload.currency))
        .then(response => {
            if(response?.payload?.all_banks) {
                const result = response.payload?.all_banks
                const options =  result?.map(bank =>  { 
                    return {value: bank.bank_name, label: bank.bank_name} 
                 })
                setState(prev => ({ ...prev,  banks: options, bankList: result  }) );
            }
        }) 
    };

    const handleBankSelection = (e) => {
        const value = e.value
        if(value !== " ") {
            let bank = state.bankList.filter(b => b.bank_name === value)[0]
            setState((prevState)=> ({...prevState, payload:{...prevState.payload, bank_code: bank.bank_code, bank_name: value}}))
        }
    }
       
    const convertTransferCurrency = () => {
        let from_currency = state.payload.currency
        let to_currency = 'NGN'
        let amount = state.payload.amount
        let rate = state.rates.find((rate) => rate.currency === from_currency)
        if(rate) {
            setState((prevState) => ({
                ...prevState, 
                converted: {
                    ...prevState.converted, 
                    amount: amount * rate.rate, 
                    currency: to_currency,
                    from_currency: from_currency,
                },
            }))
        }
    }

    return (
        <Layout>
            <Container className="mt-4 px-4 mb-4">
                <Col md={12} className="row align-items-center justify-content-between flex-wrapd">
                    <div className="col-md-4">
                        <p>
                            <h3 className="m-0">FaasPay</h3>
                            <small>Receive Paycode from abroad</small>
                        </p>                        
                    </div>
                    <div className="col-md-8">
                        <Button 
                            type="button" 
                            variant="light" 
                            className="border-0 bg-white text-primary mb-2 px-3"
                            onClick={ () => setState((prevState) => ({...prevState, showBalance: true}))}
                        >
                            <FontAwesomeIcon icon={'eye'}/>
                            <span className="ps-2">Check balance</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mb-2 mx-1"
                            onClick={ () => setState((prevState) => ({...prevState, showForm: true}))}
                        >
                            <FontAwesomeIcon icon={'plus'} />
                            <span className="ps-2">Apply PayCode</span>
                        </Button>
                        {
                            user?.user_type === 'owner' && 
                            <Button 
                                type="button" 
                                variant="primary" 
                                className="border-0 mb-2 mx-1 px-4"
                                onClick={ () => setState((prevState) => ({...prevState, withdrawal: true}))}
                            >
                                <FontAwesomeIcon icon={'print'} />
                                <span className="ps-2">Withdraw</span>
                            </Button>
                        }
                        <Button 
                            type="button" 
                            variant="light" 
                            className="text-primary bg---primary-faint border-0 mx-2z mb-2 px-4"
                            onClick={ () => setState((prevState) => ({...prevState, fxForm: true}))}
                        >
                            <FontAwesomeIcon icon={'dollar-sign'} />
                            <span className="ps-2">Sell</span>
                        </Button>
                        <Button 
                            type="button" 
                            variant="primary" 
                            className="border-0 mx-1 mb-2"
                            onClick={ () => setState((prevState) => ({...prevState, transferForm: true}))}
                        >
                            <FontAwesomeIcon icon={'money-bill-wave'} />
                            <span className="ps-2">Send Money</span>
                        </Button>
                    </div>
                </Col>

                <div className="mt-4">
                    {
                        state.loading ? (
                            <div className="page-loader">
                                <Spinner size="lg" variant="primary"/>
                            </div>
                        ) : null
                    }
                    <Row className="data-card mb-4">
                        {
                            wallets.map((wallet) => (
                                <Col md={3} className="mb-3" key={wallet.currency}>
                                    <Card className="border-0 shadow-sm bg--dark rounded-14 h-100">
                                        <Card.Body className="d-flex flex-column p-3">
                                            <p className="text-muted mb-2 small">{wallet.name} Balance</p>
                                            <div className="mb-3 flex-grow-1">
                                                <h3 className="font-bold mb-0">
                                                    {
                                                        wallet.currency === 'NGN' ?
                                                            formatCurrency(state.wallet?.amount, wallet.currency).with_currency 
                                                            : 
                                                            formatCurrency(state.wallet?.[wallet.api_label], wallet.currency).with_currency
                                                    }
                                                </h3>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <img 
                                                    src={wallet.logo} 
                                                    alt={wallet.currency} 
                                                    className="me-2" 
                                                    width="24" 
                                                    height="24"
                                                />
                                                <span className="text-muted small">{wallet.currency} Wallet</span>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>

                    <Row className="mb-4 align-items-center justify-content-between">
                        <div className="col-md-5">
                            <h5 className="mb-2">Transaction History</h5>
                        </div>
                        <div className="">
                            <RecordFilter 
                                handleInput={handleInput}
                                handleSearchSubmit={handleSearch}
                            />
                        </div>
                    </Row>

                    <Card className="border-0 shadow-sm rounded-14">
                        <Card.Body className="table-responsive-lg">
                        <Table size="sm" className="table-color table-stripedd">
                                <thead>
                                    <tr>
                                        <th>Details</th>
                                        <th>Order</th>
                                        <th>Amount</th>
                                        <th>Balance Before</th>
                                        <th>Balance After</th>
                                        <th>Type</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        state.transactions?.length ? (
                                            state.transactions?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="m-0 d-flex gap-2 align-items-center">
                                                            <small className={item.status === 'success' ? 'drews-badge drews-badge-success-circle' : 'drews-badge drews-badge-error-circle'}>
                                                                <i className="lni lni-arrow-top-right"></i>
                                                            </small>
                                                            <strong>
                                                                <p className="m-0">{item.note}</p>  
                                                                <small>{dateFormatter(item.date)}</small>
                                                            </strong>
                                                        </div>
                                                    </td>
                                                    <td> {item.order}  </td>
                                                    <td>{formatCurrency(item.amount, item.currency).with_currency}</td>
                                                    <td>{formatCurrency(item.amount_before, item.currency).with_currency} </td>
                                                    <td>{formatCurrency(item.amount_after, item.currency).with_currency} </td>
                                                    <td>
                                                        <p className="m-0 d-flex align-items-center gap-2">
                                                            <FontAwesomeIcon icon="fa fa-money-check"/>
                                                            {item.transaction_type}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex m-0 align-items-center justify-content-between">
                                                            <Badge 
                                                                className={item.status === 'success' ? 'badge-active' : 
                                                                (item.status === 'failed' ? 'badge-failed' : 
                                                                (item.status === 'used' ? 'badge-used' : 'badge-pending'))}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                                    <circle cx="5" cy="5" r="5" fill={
                                                                        item.status === 'success' ? "#008000" : 
                                                                        (item.status === 'failed' ? "#EB5757" : 
                                                                        (item.status === 'used' ? "#828282" : "#FAB941"))
                                                                    }
                                                                    />
                                                                </svg>
                                                                <span className="ps-1">
                                                                    {item.status}
                                                                </span>
                                                            </Badge> 
                                                            <Dropdown>
                                                                <Dropdown.Toggle variant="light" className="border-0 bg-transparent" size="sm" id="dropdown-basic">
                                                                    <FontAwesomeIcon icon="ellipsis-vertical" style={{fontSize: "20px"}} className="text-muted"/>
                                                                </Dropdown.Toggle>
    
                                                                <Dropdown.Menu className="border-0 shadow px-3 py-4">
                                                                    <Dropdown.Item 
                                                                        eventKey={1} 
                                                                        className="text-primary d-flex align-items-center gap-1" 
                                                                        onClick={() => selectTransaction(item.reference)}
                                                                    >
                                                                    <i className="lni lni-eye" style={{fontSize: "20px"}}></i>  View Details
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Divider />
                                                                    <Dropdown.Item 
                                                                        eventKey={2} 
                                                                        className="text-danger d-flex align-items-center gap-1"
                                                                        onClick={ () => selectTransaction(item.reference) }
                                                                    >
                                                                        <i className="lni lni-question-circle"></i> Report Transaction
                                                                    </Dropdown.Item>
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )
                                        : 
                                        (
                                            <tr>
                                                <td colSpan={5} className="text-center text-muted">No data found</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                        </Table>
                        </Card.Body>
                    </Card>
                    {
                        state.paycodes?.length ? (
                            <div className="table-responsive mt-2">
                                <Paginator
                                    next={state.paginationData.next}
                                    prev={state.paginationData.prev}
                                    setCurrentPage={ handlePagination }
                                />
                            </div>
                        ) : null
                    }
                </div>

                {/* Widget modal */}
                <Modal
                    size="sm"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={state.show_widget}
                    backdrop="static"
                >
                    {
                        state.widget_state === 'second' ? (
                            <Modal.Header className="text-sm p-2">How it works</Modal.Header>
                        ) : null
                    }
                    <Modal.Body className="py-3 px-4">
                        {
                            state.widget_state === 'second' ? (
                                <div className="second">
                                    <ol className="ps-1">
                                        <li className="text-muted text-xs mb-1">
                                            Get your paycode in USD or CAD
                                        </li>
                                        <li className="text-muted text-xs mb-1">
                                            Apply paycode, your wallet will be funded
                                        </li>
                                        <li className="text-muted text-xs mb-1">
                                            Sell your USD or CAD to Naira
                                        </li>
                                        <li className="text-muted text-xs mb-1">
                                            Withdraw to your designated bank account
                                        </li>
                                    </ol>
                                    <div className="mt-4 mb-3 text-center">
                                        <button 
                                            type="button" 
                                            className="btn-plain border p-2 rounded-3 border-1 text-primary bg-white text-sm w-100"
                                            onClick={ manageWidget }
                                        > I understand
                                        </button>
                                    </div>
                                </div>
                            )
                            : (
                                <div className="first text-center">
                                    <img src={fase} alt="wallet" />
                                    <h5 className="mt-3">Welcome to FasPay</h5>
                                    <p className="mt-3 text-muted text-sm">Recieve Paycode from abroad and sell to get naira</p>
                                    <div className="text-center mt-4 mb-3">
                                        <button 
                                            type="button" 
                                            className="btn-plain border p-2 rounded-3 border-1 text-primary bg-white text-sm"
                                            onClick={ () => setState((prevState) => ({...prevState, widget_state: 'second'}))}
                                        > See how it works
                                        </button>
                                    </div>
                                </div>
                            )
                        }
                    </Modal.Body>
                </Modal>

                <DrewsModal
                    show={state.modalShow}
                    onHide={() => setState((prevState) => ({...prevState, modalShow: false}))}
                    size="lg"
                    dismissable={true}
                    title={state.transaction.reference}
                >
                    <Row>
                        <Col md={6}>
                            <div className="modal-profile">
                                <ul>
                                    <li>
                                        <div>
                                            <p className="pt-2">
                                                <small className="text-muted">Voucher Balance</small>
                                                {state.transaction.amount} 
                                            </p>
                                        </div>
                                    </li>
                                </ul>

                            </div>
                        </Col>
                        <Col md={6} className="modal-profile">
                            <ul>
                                <li>
                                    <div>
                                        <p className="pt-2">
                                            <small className="text-muted">Valid Till</small>
                                            
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </DrewsModal>

                <DrewsModal
                    show={state.showBalance}
                    onHide={() => setState((prevState) => ({...prevState, showBalance: false}))}
                    size="md"
                    dismissable={true}
                    title="Check PayCode Balance"
                >
                    <Form>
                        <Row>
                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Enter PayCode</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="PayCode"
                                    name="paycode"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                    minLength={6}
                                    maxLength={6}
                                />
                                {
                                    state.errors['paycode'] && 
                                    <Form.Text className="text-danger">{state.errors['paycode']}</Form.Text>
                                }
                            </Form.Group>

                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Secret Word</Form.Label>
                                <Form.Control
                                    type="password"
                                    required
                                    placeholder="Secret Word"
                                    name="secret_word"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                />
                                {
                                    state.errors['secret_word'] && 
                                    <Form.Text className="text-danger">{state.errors['secret_word']}</Form.Text>
                                }
                            </Form.Group>
                                <p className="text-danger text-sm">
                                    {state.errorMessage}
                                </p>
                            <Form.Group 
                                as={Col} 
                                md="12" 
                                controlId="validationCustom011" 
                                className="mt-4 d-grid"
                            >
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={paycodeBalance}
                                    disabled={Object.keys(state.errors).length > 0}
                                >
                                    Check Balance <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Row>
                    </Form>
                </DrewsModal>

                <DrewsModal
                    show={state.genVoucher}
                    onHide={() => setState((prevState) => ({...prevState, genVoucher: false}))}
                    size="md"
                    dismissable={true}
                    title="Generate PayCode"
                >
                    <Form>
                        <p className="text-sm">Generate new paycode.</p>
                        <Row>
                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Amount</Form.Label>
                                <Form.Control
                                    type="text"
                                    required
                                    placeholder="0.00"
                                    name="amount"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                    value={ parseFloat(state.payload.amount) > 0 ? formatCurrency(state.payload.amount).formatted : ''}
                                />
                                {
                                    state.errors['amount'] && 
                                    <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                }
                            </Form.Group>

                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Quantity</Form.Label>
                                <Form.Control
                                    type="number"
                                    required
                                    placeholder="e.g: 1"
                                    name="qty"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                    min={1}
                                />
                                {
                                    state.errors['qty'] && 
                                    <Form.Text className="text-danger">{state.errors['qty']}</Form.Text>
                                }
                            </Form.Group>
                            
                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Secret Word</Form.Label>
                                <Form.Control
                                    type="password"
                                    required
                                    placeholder="Secret Word"
                                    name="secret"
                                    onChange={handleInput}
                                    onKeyUp={handleValidation}
                                />
                                {
                                    state.errors['secret'] && 
                                    <Form.Text className="text-danger">{state.errors['secret']}</Form.Text>
                                }
                            </Form.Group>
                                <p className="text-danger text-sm">
                                    {state.errorMessage}
                                </p>
                            <Form.Group 
                                as={Col} 
                                md="12" 
                                controlId="validationCustom011" 
                                className="mt-4 d-grid"
                            >
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={createPayCode}
                                    disabled={Object.keys(state.errors).length > 0}
                                >
                                    Generate PayCode <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Row>
                    </Form>
                </DrewsModal>

                <DrewsModal
                    show={state.showForm}
                    onHide={() => setState((prevState) => ({...prevState, showForm: false}))}
                    size="md"
                    dismissable={true}
                    title="Apply PayCode"
                >
                    <Form>
                        <p className="text-sm">New Paycode will be added to your wallet automatically.</p>
                        <Row>
                            <Form.Group as={Col} md="12" className="mb-3">
                            <Form.Label className="mb-0">
                                PayCode <span className="text-danger">*</span>
                            </Form.Label>
                            <InputGroup>
                                <Form.Control
                                type="text"
                                required
                                placeholder="PayCode"
                                name="paycode"
                                onChange={handleInput}
                                onKeyUp={handleValidation}
                                minLength={6}
                                maxLength={6}
                                />
                                <Button 
                                    variant="primary" 
                                    onClick={fetchPaycodeDetails} 
                                    disabled={state.payload.paycode === ''}
                                >
                                    Verify
                                </Button>
                            </InputGroup>
                            {state.errors['paycode'] && (
                                <Form.Text className="text-danger">{state.errors['paycode']}</Form.Text>
                            )}
                            </Form.Group>

                            {
                                faasPaycode?.currency && (
                                    <div>
                                        <div className="text-center">
                                            <Spinner animation={ state.loadingRequest ? "border" : null} role="status" size="sm"></Spinner>
                                        </div>
                                        <p className="m-0 text-danger"><small>Please confirm the paycode details before you proceed.</small></p>
                                        <p className="m-0"><strong>Currency</strong>: { faasPaycode?.currency } </p>
                                        <p className="m-0"><strong>Amount</strong>: { formatCurrency(faasPaycode?.amount, faasPaycode?.currency).with_currency } </p>
                                        <p className="m-0"><strong>Payee</strong>: { faasPaycode?.payee_name } </p>
                                        <p className="m-0"><strong>Reason</strong>: { faasPaycode?.payment_reasons } </p>
                                        <div className="text-right">
                                            <Button 
                                                type="button" 
                                                variant="primary" 
                                                size="sm"
                                                onClick={ () => setProceed(!proceedToPayment) }
                                            >
                                                Proceed
                                            </Button>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                proceedToPayment && (
                                    <>
                                        <Form.Group as={Col} md="12" className="mb-3">
                                            <Form.Label className="mb-0">Secret Word <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="password"
                                                required
                                                placeholder="Secret Word"
                                                name="secret_word"
                                                onChange={handleInput}
                                                onKeyUp={handleValidation}
                                            />
                                            {
                                                state.errors['secret_word'] && 
                                                <Form.Text className="text-danger">{state.errors['secret_word']}</Form.Text>
                                            }
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" className="mb-3">
                                            <Form.Label className="mb-0">Currency/Amount <span className="text-danger">*</span> </Form.Label>
                                            <div className="d-flex">
                                                <div className="w-25">
                                                    <Form.Select 
                                                        name="currency"
                                                        required
                                                        onChange={handleInput}
                                                        onKeyUp={handleValidation}
                                                    >
                                                        <option value="">Select</option>
                                                        {
                                                            wallets.map(x => (
                                                                <option 
                                                                    value={x.currency} 
                                                                    key={x.currency} 
                                                                    // selected={ x.currency === faasPaycode.currency }
                                                                >
                                                                    {x.currency}
                                                                </option>
                                                            ))
                                                        }
                                                    </Form.Select>
                                                </div>
                                                <div className="ms-2 w-75">
                                                    <AmountInput 
                                                        onChange={handleAmountUpdate} 
                                                    />
                                                </div>
                                            </div>
                                            {
                                                state.errors['amount'] && 
                                                <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                            }
                                        </Form.Group>
                                    </>
                                )
                            }
                            <p className="text-danger text-sm">
                                {state.errorMessage}
                            </p>
                            <Form.Group 
                                as={Col} 
                                md="12" 
                                className="d-grid"
                            >
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={applyPaycode}
                                    disabled={Object.keys(state.errors).length > 0 || !proceedToPayment}
                                >
                                    Apply PayCode <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Row>
                    </Form>
                </DrewsModal>

                <DrewsModal
                    show={state.fxForm}
                    onHide={() => setState((prevState) => ({...prevState, fxForm: false}))}
                    size="md"
                    dismissable={true}
                    title="Sell USD/CAD"
                >
                    <Form>
                        <div className="d-flex justify-content-between text-sm">
                           <p>USD Wallet Balance: {formatCurrency(state.wallet?.usd_amount, 'USD').with_currency}  </p> 
                            
                           <p>state. Balance: {formatCurrency(state.wallet?.amount).with_currency}</p>
                        </div>
                        <Row>
                            <Form.Group as={Col} md="12" className="mb-3">
                                <Form.Label className="mb-0">Amount</Form.Label>
                                <div className="d-flex">
                                    <div className="w-25">
                                        <CurrencyDropdown value={state.payload.currency}  onChange={ (e) => handleCurrencySelect(e, 'currency') } />
                                    </div>
                                    <div className="ms-2 w-75">
                                        <Form.Control
                                            type="text"
                                            required
                                            placeholder="0.00"
                                            name="amount"
                                            onChange={handleInput} 
                                        />
                                    </div>
                                </div>
                                <p className="text-secondary text-xs font-bold m-0 mb-3">
                                    Minimum amount you can sell: $10 or 10 CAD
                                </p>
                                {
                                    state.errors['amount'] && 
                                    <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                }
                            </Form.Group>

                            <div className="divider custom-divider">
                                <img src={rotateKnob} alt="knob" className="knob" />
                            </div>

                            <Form.Group as={Col} md="12" className="mb-3 mt-4">
                                <Form.Label className="mb-0">You will get</Form.Label>
                                <div className="d-flex">
                                    <div className="w-25">
                                        <CurrencyDropdown onChange={ (e) => handleCurrencySelect(e, 'to_currency') } />
                                    </div>
                                    <div className="ms-2 w-75">
                                        <Form.Control
                                            type="text"
                                            required
                                            readOnly
                                            placeholder="0.00"
                                            name="to_amount"
                                            value={ parseFloat(state.conversion.amount) > 0 ? formatCurrency(state.conversion.amount).formatted : ''}
                                        />
                                    </div>
                                </div>
                            </Form.Group>


                            <p className="text-danger text-sm">
                                {state.errorMessage}
                            </p>

                            <div className="bg---primary-faint text-primary rounded-16 mt-1 mb-3 py-2 w-75 m-auto">
                                <p className="m-0 text-sm">
                                    <FontAwesomeIcon icon={'info-circle'} />
                                   <span className="text-xs font-bold ms-1">Conversion rate $1 = {formatCurrency(usd_to_nara?.rate).with_currency}, 1CAD = {formatCurrency(cad_to_nara?.rate).with_currency} </span> 
                                </p>
                            </div>

                            <Form.Group 
                                as={Col} 
                                md="12" 
                                className="d-grid"
                            >
                                <Button 
                                    variant="primary" 
                                    size="lg" 
                                    onClick={sellFx}
                                    disabled={Object.keys(state.errors).length > 0}
                                >
                                    Sell {state.payload.currency} <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Row>
                    </Form>
                </DrewsModal>


                {/* Wallet withdrawal modal */}
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={state.withdrawal}
                    onHide={() => setState((prevState) => ({...prevState, withdrawal: false}))}
                    backdrop="static" 
                >
                    <Modal.Header closeButton>Withdraw Funds</Modal.Header>
                    <Modal.Body className="p-4">
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Account Name</Form.Label>
                                    <Form.Control
                                        readOnly
                                        type="text"
                                        placeholder="Account Name"
                                        name="account_name"
                                        value={state.wallet?.account_name}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Account Number</Form.Label>
                                    <Form.Control
                                        readOnly
                                        type="text"
                                        placeholder="Account Number"
                                        name="account_number"
                                        value={state.wallet?.account_number}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Bank</Form.Label>
                                    <Form.Control
                                        readOnly
                                        type="text"
                                        placeholder="Bank"
                                        name="bank_name"
                                        value={state.wallet?.bank_name}
                                    />
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Amount(NGN)</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="₦0.00"
                                        name="amount"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                        value={ parseFloat(state.payload.amount) > 0 ? formatCurrency(state.payload.amount).formatted : ''}
                                    />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }
                                    <p className="m-0 text-secondary">
                                        <small>Maximum Limit: {formatCurrency(2000000).with_currency}</small>
                                    </p>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Transaction Fee</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="₦0.00"
                                        name="total_amount"
                                        disabled
                                        value={state.fee}
                                    />
                                    <p className="m-0 text-secondary">
                                        <small>{state.charges}% fees on each withdrawal capped @ {formatCurrency(2500).with_currency}</small>
                                    </p>
                                </Form.Group>
                                <Form.Group>
                                    <p>4-Digit Transaction PIN</p>
                                    <div className="otp-boxes w-50">
                                        {
                                            Array.from({length: 4}, (item, indexx) => (
                                                <input 
                                                    type="text" 
                                                    maxLength={1} 
                                                    minLength={1} 
                                                    className="box" 
                                                    key={indexx}
                                                    onChange={ (e) => handleOtpInputs(indexx, e) }
                                                    ref={ inputRefs[indexx] }
                                                />
                                            ))
                                        }
                                    </div>
                                    <small className="mt-1 text-muted">Enter wallet PIN</small>
                                </Form.Group>
                            </Row>
                            <Form.Group className="mt-4">
                                <Button 
                                    type="button"
                                    variant="primary" 
                                    className="form-control" 
                                    size="lg"
                                    onClick={sendWithrawalRequest}
                                    disabled={Object.keys(state.errors).length > 0 || state.pinValue.join("").length < 4}
                                >
                                    Withdraw funds <Spinner animation={ state.loading ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                </Modal>

                {/* Transfer modal */}
                <Modal
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={state.transferForm}
                    onHide={() => setState((prevState) => ({...prevState, transferForm: false}))}
                    backdrop="static" 
                >
                    <Modal.Header closeButton>International Transfers</Modal.Header>
                    <Modal.Body className="p-4">
                        <Form>
                            <Row>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Currency</Form.Label>
                                    <Form.Select 
                                        name="currency"
                                        required
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    >
                                        <option value="">Select</option>
                                        <option value='GHS'>GHS</option>
                                        <option value='KES'>KES</option>
                                    </Form.Select>
                                    {
                                        state.errors['currency'] && 
                                        <Form.Text className="text-danger">{state.errors['currency']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Bank</Form.Label>
                                    <Select 
                                        name="bank_name" 
                                        options={state.banks}
                                        onChange={ handleBankSelection }
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                height: "45px",
                                                backgroundColor: "#f2f2f2"
                                            }),
                                        }}
                                    />
                                    {
                                        state.errors['bank_name'] && 
                                        <Form.Text className="text-danger">{state.errors['bank_name']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Account Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Account Number"
                                        name="account_number"
                                        required
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['account_number'] && 
                                        <Form.Text className="text-danger">{state.errors['account_number']}</Form.Text>
                                    }
                                </Form.Group>

                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Amount({state.payload.currency})</Form.Label>
                                    <AmountInput 
                                        onChange={handleAmountUpdate} 
                                    />
                                    {
                                        state.errors['amount'] && 
                                        <Form.Text className="text-danger">{state.errors['amount']}</Form.Text>
                                    }

                                    <p className="m-0 text-secondary mt-2">
                                        <small>Transfer Amount in NGN: { formatCurrency(state.converted?.amount, 'NGN').with_currency }</small>
                                    </p>
                                </Form.Group>
                                <Form.Group as={Col} md={12} className="mb-3">
                                    <Form.Label className="mb-0 text-sm">Narration</Form.Label>
                                    <Form.Control
                                        required
                                        type="text"
                                        placeholder="Transfer to xyz"
                                        name="narration"
                                        onChange={handleInput}
                                        onKeyUp={handleValidation}
                                    />
                                    {
                                        state.errors['narration'] && 
                                        <Form.Text className="text-danger">{state.errors['narration']}</Form.Text>
                                    }
                                </Form.Group>
                                <Form.Group>
                                    <p>4-Digit Transaction PIN</p>
                                    <div className="otp-boxes w-50">
                                        {
                                            Array.from({length: 4}, (item, indexx) => (
                                                <input 
                                                    type="text" 
                                                    maxLength={1} 
                                                    minLength={1} 
                                                    className="box" 
                                                    key={indexx}
                                                    onChange={ (e) => handleOtpInputs(indexx, e) }
                                                    ref={ inputRefs[indexx] }
                                                />
                                            ))
                                        }
                                    </div>
                                    <small className="mt-1 text-muted">Enter wallet PIN</small>
                                </Form.Group>
                            </Row>
                            <Form.Group className="mt-4">
                                <Button 
                                    type="button"
                                    variant="primary" 
                                    className="form-control" 
                                    size="lg"
                                    onClick={initiateTransfer}
                                    disabled={Object.keys(state.errors).length > 0 || state.pinValue.join("").length < 4}
                                >
                                    Send Money <Spinner animation={ state.sendingRequest ? "border" : null} role="status" size="sm"></Spinner>
                                </Button>
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                </Modal>

            </Container>
        </Layout>
    );
}

export default FasePay;